import React from "react";
import {
  Box,
  FormControlLabel,
  FormControl,
  Checkbox,
  Typography,
  Button,
  TablePagination,
  AppBar,
  Tabs,
  Tab,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Grid,
  IconButton,
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import stations from "./cires";
import { fetchIntensityAction } from "../../actions/monitoring/earthquakeActions";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import LocationOnIcon from "@material-ui/icons/LocationOn";
import { withSnackbar } from "notistack";
import "./Earthquake.css";
//Obtiene la url del proxie para los casos donde se invocan servicios por http
const proxieURL = process.env.REACT_APP_PROXIE;

var baseEarthquakeSize = 10;
//Colores para los circulos del mapa
var yellowColor = [255, 191, 0];
var greenColor = [64, 171, 93];
var whiteColor = [255, 255, 255];
var darkColor = [0, 0, 0];

var entre0y1Gal = [185, 185, 255];
var entre1y2Gal = [116, 201, 252];
var entre2y5Gal = [110, 215, 40];
var entre5y10Gal = [253, 221, 125];
var entre10y50Gal = [243, 161, 69];
var entre50y120Gal = [255, 93, 107];
var entre120yMas = [174, 99, 102];

//Nombre de las capas del mapa que utiliza el componente
var layerNames = {
  Sismos: "ssn",
  Intensidad: "ssni",
};
//Estilos del componente
const useStyles = (theme) => ({
  info: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
  },
});

//Componente para los tabs
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </Box>
  );
}

//Propiedades de los tabs
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

//Componente de Sismos
class Earthquake extends React.Component {
  //Definición del estado inicial del componente
  constructor(props) {
    super(props);
    this.state = {
      ssn: false,
      intensity: false,
      ssnData: [],
      intensityData: null,
      page: 0,
      tabIndex: 0,
      rowsPerPage: 10,
    };
  }

  //Establece el estado del componente en caso de error en la llamada del servicio
  getDummyPointData = () => {
    this.props.enqueueSnackbar(
      "Error al obtener los datos del servicio de sismos",
      {
        variant: "warning",
      }
    );
    this.setState({
      ssnData: [],
    });
  };

  //Abre nueva ventana con la url del sitio indicado
  openSite = (site) => {
    window.open(site, "_blank");
  };

  //Ejecuta la accion para obtener los puntos de Aceleración
  getIntensityPoints = () => {
    this.props.fetchIntensityAction();
  };

  //Obtiene los puntos del serivicio de sismos
  getPoints = async () => {
    let layer = this.props.moduleLayers.find(
      (l) => l.nombre === layerNames.Sismos
    );
    var serviceUrl = `${proxieURL}${layer.url}`;

    const res = await fetch(serviceUrl, {
      method: "GET",
      timeout: 8000,
    }).catch((err) => {
      this.getDummyPointData();
    });

    if (res) {
      if (res.status === 200) {
        let data = await res.json();

        this.setState(
          {
            ssnData: data,
          },
          () => {
            this.drawPoints(layerNames.Sismos, data);
          }
        );
      } else {
        this.getDummyPointData();
      }
    }
  };

  //Coinfigura y agrega puntos al mapa de los eventos sísmicos
  addPoint = (layerId, evento, esUltimo) => {
    const { esri } = this.props;
    let objLayer = this.props.mapView.getLayer(layerId);
    var size;

    var infoTemplateSismo = new esri.InfoTemplate(
      esUltimo ? "Último evento sísmico" : "Evento sísmico",
      "Fecha: " +
        evento.fecha +
        "<br/>" +
        "Hora: " +
        evento.hora +
        "<br/>" +
        "Magnitud: " +
        evento.magnitud +
        "<br/>" +
        "Lugar: " +
        evento.lugar +
        "<br/>" +
        "Latitud: " +
        evento.latitud +
        "<br/>" +
        "Longitud: " +
        evento.longitud
    );

    if (parseFloat(evento.magnitud) <= 4) size = baseEarthquakeSize;
    else if (parseFloat(evento.magnitud) > 4) size = baseEarthquakeSize + 2;
    else if (parseFloat(evento.magnitud) > 5) size = baseEarthquakeSize + 4;
    else if (parseFloat(evento.magnitud) > 6) size = baseEarthquakeSize + 6;
    else if (parseFloat(evento.magnitud) > 7) size = baseEarthquakeSize + 8;
    else if (parseFloat(evento.magnitud) > 8) size = baseEarthquakeSize + 10;

    for (var j = 0; j <= 4; j++) {
      var sms = new esri.SimpleMarkerSymbol(
        esri.SimpleMarkerSymbol.STYLE_CIRCLE,
        size,
        new esri.SimpleLineSymbol(
          esri.SimpleLineSymbol.STYLE_SOLID,
          new esri.Color(whiteColor),
          1
        ),
        new esri.Color(esUltimo ? yellowColor : greenColor)
      );
      var eventoLoc = new esri.Point(evento.longitud, evento.latitud);
      var graphic = new esri.Graphic(eventoLoc, sms);
      graphic.setAttributes({ type: esUltimo ? "ultimoSismo" : "sismo" });
      graphic.setInfoTemplate(infoTemplateSismo);
      objLayer.add(graphic);
    }
  };

  //Renderea los puntos en el mapa del servicio de sísmos
  drawPoints = (layerId, data) => {
    const { esri } = this.props;
    let objLayer = this.props.mapView.getLayer(layerId);

    objLayer.clear();

    if (data.eventos[1]) {
      for (var i = 1; i < data.eventos.length; i++) {
        this.addPoint(layerId, data.eventos[i], false);
      }
    }

    this.addPoint(layerId, data.eventos[0], true);

    this.props.mapView.setExtent(
      esri.graphicsUtils.graphicsExtent(objLayer.graphics).expand(1.2)
    );
  };

  //Coinfigura y agrega puntos al mapa de los eventos Aceleración
  addIntensityPoint = (layerId, estacion) => {
    const { esri } = this.props;
    let objLayer = this.props.mapView.getLayer(layerId);
    var size;

    var infoTemplateSismo = new esri.InfoTemplate(
      "Estación " + estacion.station?.clave,
      "Clave: " +
        estacion.station?.clave +
        "<br/>" +
        "Nombre: " +
        estacion.station?.nombre +
        "<br/>" +
        "Dirección: " +
        estacion.station?.direccion +
        "<br/>" +
        "Latitud: " +
        estacion.station?.latlng[0] +
        "<br/>" +
        "Longitud: " +
        estacion.station?.latlng[1]
    );

    let fillColor = entre0y1Gal;

    size = baseEarthquakeSize + 15;
    if (parseFloat(estacion.valor) < 1) fillColor = entre0y1Gal;
    else if (estacion.valor >= 1 && estacion.valor < 2) fillColor = entre1y2Gal;
    else if (estacion.valor >= 2 && estacion.valor < 5) fillColor = entre2y5Gal;
    else if (estacion.valor >= 5 && estacion.valor < 10)
      fillColor = entre5y10Gal;
    else if (estacion.valor >= 10 && estacion.valor < 50)
      fillColor = entre10y50Gal;
    else if (estacion.valor >= 50 && estacion.valor < 120)
      fillColor = entre50y120Gal;
    else if (estacion.valor >= 120) fillColor = entre120yMas;

    // for (var j = 0; j <= 4; j++) {
    var sms = new esri.SimpleMarkerSymbol(
      esri.SimpleMarkerSymbol.STYLE_CIRCLE,
      size,
      new esri.SimpleLineSymbol(
        esri.SimpleLineSymbol.STYLE_SOLID,
        new esri.Color(darkColor),
        1
      ),
      new esri.Color(fillColor)
    );
    var estacionLoc = new esri.Point(
      estacion.station?.latlng[1],
      estacion.station?.latlng[0]
    );
    var graphic = new esri.Graphic(estacionLoc, sms);
    graphic.setAttributes({ type: "intensidad" });
    graphic.setInfoTemplate(infoTemplateSismo);
    var graphic2 = new esri.Graphic(estacionLoc);

    let textSymbol = new esri.TextSymbol(estacion.station?.clave);

    textSymbol.setColor(darkColor);
    textSymbol.font.size = 18;
    textSymbol.font.weight = "bold";
    textSymbol.setOffset(35, 10);
    textSymbol.color = fillColor;
    graphic2.setSymbol(textSymbol);
    objLayer.add(graphic);
    objLayer.add(graphic2);
  };

  //Renderea los puntos en el mapa del servicio de Aceleración
  drawIntensityPoint = (layerId, data) => {
    const { esri } = this.props;
    let objLayer = this.props.mapView.getLayer(layerId);
    objLayer.clear();

    data.sensores?.forEach((s) => {
      if (s.station) {
        this.addIntensityPoint(layerId, s);
      }
    });

    data.otrosSensores?.forEach((s) => {
      if(s.estacion !='TenemosSismo' || s.estacion !='ipClient1')
      {
        if (s.station) {
          this.addIntensityPoint(layerId, s);
        }
      }
    });
    if (objLayer.graphics.length > 0)
      this.props.mapView.setExtent(
        esri.graphicsUtils.graphicsExtent(objLayer.graphics).expand(1.2)
      );
  };

  //Maneja los eventos de cambio de estado del los controles checkbox
  handleChangeCheck = (e) => {
    const { name, checked } = e.target;
    this.setState({ [name]: checked }, () => {
      if (name === "ssn") {
        let layer = this.props.mapView.getLayer(layerNames.Sismos);
        layer.setVisibility(checked);
        if (checked) {
          this.getPoints();
        }
      }
      if (name === "intensity") {
        let layer = this.props.mapView.getLayer(layerNames.Intensidad);
        layer.setVisibility(checked);
        if (checked) {
          this.getIntensityPoints();
        }
      }
    });
  };

  //Ejecuta un acercamiento al mapa dado un punto de sísmos
  zoomIn = (p) => {
    var point = new this.props.esri.Point(p.longitud, p.latitud);
    this.props.mapView.centerAndZoom(point, 8);
  };

  //Ejecuta un acercamiento al mapa dado un punto de aceleración
  zoomInIntensity = (p) => {
    var point = new this.props.esri.Point(
      p.station?.latlng[1],
      p.station?.latlng[0]
    );
    this.props.mapView.centerAndZoom(point, 16);
  };

  //Renderea los datos de sísmo en el panel de información
  renderPoints() {
    let data = this.state.ssnData;
    let rowsPerPage = this.state.rowsPerPage;
    let page = this.state.page;

    let from = page * rowsPerPage;
    let to = page * rowsPerPage + rowsPerPage;
    let currentRows = [];
    let total = 0;

    if (data?.eventos) {
      total = data?.eventos.length;
      currentRows = data.eventos.slice(from, to);
    }
    let i = 0;

    return (
      <Box mt={1} mb={4}>
        {total > 0 ? (
          currentRows.map((p) => {
            return (
              <Box p={1} mb={2} key={i++} component={Paper}>
                <Box>
                  <Button onClick={() => this.zoomIn(p)}>
                    <Typography
                      variant="overline"
                      style={{ fontWeight: "bolder" }}
                    >
                      Fecha: {p.fecha} {p.hora}
                    </Typography>
                  </Button>
                </Box>
                <Box ml={2}>
                  <Typography
                    display="inline"
                    variant="caption"
                    color="primary"
                  >
                    Magnitud:{" "}
                  </Typography>
                  <Typography display="inline" variant="caption">
                    {p.magnitud}
                  </Typography>
                </Box>

                <Box ml={2}>
                  <Typography
                    display="inline"
                    variant="caption"
                    color="primary"
                  >
                    Latitud:{" "}
                  </Typography>
                  <Typography display="inline" variant="caption">
                    {p.latitud}
                  </Typography>
                </Box>
                <Box ml={2}>
                  <Typography
                    display="inline"
                    variant="caption"
                    color="primary"
                  >
                    Longitud:{" "}
                  </Typography>
                  <Typography display="inline" variant="caption">
                    {p.longitud}
                  </Typography>
                </Box>
                <Box ml={2}>
                  <Typography
                    display="inline"
                    variant="caption"
                    color="primary"
                  >
                    Descripción:{" "}
                  </Typography>
                  <Typography display="inline" variant="caption">
                    {p.lugar}
                  </Typography>
                </Box>
                <Box ml={2}>
                  <Typography
                    display="inline"
                    variant="caption"
                    color="primary"
                  >
                    Profundidad:{" "}
                  </Typography>
                  <Typography display="inline" variant="caption">
                    {p.profundidad}
                  </Typography>
                </Box>
              </Box>
            );
          })
        ) : (
          <Typography variant="overline">Cargando datos...</Typography>
        )}

        {total > 0 && (
          <TablePagination
            rowsPerPageOptions={[10, 20]}
            component="div"
            count={total}
            rowsPerPage={rowsPerPage}
            page={page}
            onChangePage={(e, newPage) => {
              this.setState({ page: newPage });
            }}
            onChangeRowsPerPage={(e) => {
              this.setState({ rowsPerPage: parseInt(e.target.value, 10) });
            }}
          />
        )}
      </Box>
    );
  }

  //Renderea la escala de aceleración
  renderEscIntens(color, texto) {
    return (
      <TableRow>
        <TableCell component="th" scope="row">
          <Typography variant="caption" display="block">
            <Box
              borderRadius="50%"
              border={1}
              style={{
                display: "inline",
                backgroundColor: `rgb(${color})`,
              }}
              mr={1}
            >
              &nbsp;&nbsp;&nbsp;&nbsp;
            </Box>
            {texto}
          </Typography>
        </TableCell>
      </TableRow>
    );
  }

  //Renderea los datos de aceleración en el panel de información
  renderIntensity() {
    const { intensityData } = this.state;
    const { classes } = this.props;
    if (intensityData) {
      let sensores = intensityData.sensores;
      let otros = intensityData.otrosSensores;

      return (
        <Box my={2}>
          <Box component={Paper} p={1} mb={1}>
            <Typography variant="caption" display="block">
              Fecha:{" "}
              <Typography variant="caption" style={{ fontWeight: "bold" }}>
                {intensityData.fecha}
              </Typography>
            </Typography>
          </Box>
          <Grid container>
            <Grid item xs={6}>
              <Typography variant="overline" color="primary">
                Aceleraciones CDMX
              </Typography>
              <TableContainer component={Paper} style={{ marginRight: 10 }}>
                <Table
                  size="small"
                  className={classes.table}
                  aria-label="simple table"
                >
                  <TableHead>
                    <TableRow>
                      <TableCell>
                        <Typography
                          variant="caption"
                          style={{ fontWeight: "bold" }}
                        >
                          Sensor
                        </Typography>
                      </TableCell>
                      <TableCell align="right">
                        <Typography
                          variant="caption"
                          style={{ fontWeight: "bold" }}
                        >
                          cm/s2
                        </Typography>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {sensores?.map((row) => (
                      <TableRow key={row.id}>
                        <TableCell component="th" scope="row">
                          <Typography variant="caption" display="block">
                            {row.estacion}
                            {"  "}
                            {row.station && (
                              <IconButton
                                size="small"
                                onClick={() => {
                                  this.zoomInIntensity(row);
                                }}
                              >
                                <LocationOnIcon
                                  color="primary"
                                  fontSize="small"
                                ></LocationOnIcon>
                              </IconButton>
                            )}
                          </Typography>
                        </TableCell>
                        <TableCell align="right">
                          {" "}
                          <Typography variant="caption" display="block">
                            {row.valor}
                          </Typography>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
            <Grid item xs={6}>
              <Box ml={1}>
                <Typography variant="overline" color="primary">
                  Otros sitios
                </Typography>
                <TableContainer component={Paper}>
                  <Table
                    size="small"
                    className={classes.table}
                    aria-label="simple table"
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell>
                          <Typography
                            variant="caption"
                            style={{ fontWeight: "bold" }}
                          >
                            Sensor
                          </Typography>
                        </TableCell>
                        <TableCell align="right">
                          <Typography
                            variant="caption"
                            style={{ fontWeight: "bold" }}
                          >
                            cm/s2
                          </Typography>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {otros?.map((row) => (
                        <TableRow key={row.id}>
                          <TableCell component="th" scope="row">
                            <Typography variant="caption" display="block">
                              {row.estacion}
                              {row.station && (
                                <IconButton
                                  size="small"
                                  onClick={() => {
                                    this.zoomInIntensity(row);
                                  }}
                                >
                                  {" "}
                                  <LocationOnIcon
                                    color="primary"
                                    fontSize="small"
                                  ></LocationOnIcon>
                                </IconButton>
                              )}
                            </Typography>
                          </TableCell>
                          <TableCell align="right">
                            <Typography variant="caption" display="block">
                              {row.valor}
                            </Typography>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
              <Box ml={1} mt={1}>
                <Typography variant="overline" color="primary">
                  Escala Intensidad
                </Typography>
                <TableContainer component={Paper}>
                  <Table
                    size="small"
                    className={classes.table}
                    aria-label="simple table"
                  >
                    <TableBody>
                      {this.renderEscIntens(entre0y1Gal, "menor a 1 gal")}

                      {this.renderEscIntens(entre1y2Gal, "de 1 a 2 gal")}
                      {this.renderEscIntens(entre2y5Gal, "de 2 a 5 gal")}
                      {this.renderEscIntens(entre5y10Gal, "de 5 a 10 gal")}
                      {this.renderEscIntens(entre10y50Gal, "de 10 a 50 gal")}
                      {this.renderEscIntens(entre50y120Gal, "de 50 a 120 gal")}
                      {this.renderEscIntens(entre120yMas, "mayor a 120 gal")}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Grid>
          </Grid>
        </Box>
      );
    } else return <Box>Cargando datos...</Box>;
  }

  //Lee los puntos de aceleración del estado general de la aplicación
  componentDidUpdate() {
    const { loadedIntensityList } = this.props;
    if (loadedIntensityList && !this.state.intensityData) {
      let list = { ...this.props.intensityList };

      list.sensores = list.sensores?.map((s) => {
        let station = stations.find(
          (st) => st.clave.trim() === s.estacion.trim()
        );
        return { ...s, geom: null, station };
      });
      
      let listOtrosSensores= list.otrosSensores?.filter((s) => {
        return (s.estacion !='ipClient1' && s.estacion !='TenemosSismo');
      });
     

      list.otrosSensores = listOtrosSensores?.map((s) => {
        let station = stations
         .find(
          (st) => st.clave.trim() === s.estacion.trim()
        );
     
        return { ...s, geom: null, station };
      });
   
      this.setState({ intensityData: list }, () => {
        this.drawIntensityPoint(
          layerNames.Intensidad,
          this.state.intensityData
        );
      });
    }
  }

  //Renderea el compoenente inicial de Sísmos
  render() {
    const { ssn, intensity, tabIndex } = this.state;
    return (
      <Box style={{ width: "100%" }}>
        <Box align="center">
          <a
            href="http://www.ssn.unam.mx/"
            color="primary"
            target="_blank"
            rel="noreferrer"
          >
            <Typography variant="caption">(SSN)</Typography>
          </a>
        </Box>
        <Box>
          <FormControl component="fieldset" size="small" fullWidth>
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  checked={ssn}
                  onChange={this.handleChangeCheck}
                  name="ssn"
                  color="primary"
                />
              }
              label={
                <Typography variant="caption">
                  Servicio Sismológico Nacional
                </Typography>
              }
            />
          </FormControl>
        </Box>
        <Box>
          <FormControl component="fieldset" size="small" fullWidth>
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  checked={intensity}
                  onChange={this.handleChangeCheck}
                  name="intensity"
                  color="primary"
                />
              }
              label={
                <Typography variant="caption">
                  Último sismo - Aceleraciones(CIRES)
                </Typography>
              }
            />
          </FormControl>
        </Box>

        <Box>
          <AppBar position="static" style={{ width: "100%" }}>
            <Tabs
              name="tabIndex"
              value={tabIndex}
              onChange={(e, n) => {
                this.setState({ tabIndex: n });
              }}
              aria-label="simple tabs results"
            >
              <Tab label="Sismos" {...a11yProps(0)} />
              <Tab label="Aceleraciones" {...a11yProps(1)} />
            </Tabs>
          </AppBar>
          <TabPanel value={tabIndex} index={0} component={Box}>
            <Box>{ssn && this.renderPoints(layerNames.Sismos)}</Box>
          </TabPanel>
          <TabPanel value={tabIndex} index={1} component={Box}>
            <Box> {intensity && this.renderIntensity()}</Box>
          </TabPanel>
        </Box>
      </Box>
    );
  }
}

//Obtiene los datos del estado general de la aplicación
const mapStateToProps = (state) => {
  return {
    intensityList: state.monitoringState.intensityList,
    loadedIntensityList: state.monitoringState.loadedIntensityList,
  };
};

export default connect(mapStateToProps, {
  fetchIntensityAction,
})(withStyles(useStyles)(withSnackbar(Earthquake)));
